var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3126 13.8593L2.5667 15.5263C1.98232 15.8857 1.98232 16.4742 2.5667 16.8336L7.48076 19.8658C8.04156 20.2112 8.96461 20.2112 9.52541 19.8658L14.4395 16.8336C15.0238 16.4742 15.0238 15.8857 14.4395 15.5263L11.7852 13.7982M14.4368 6.1835L9.4776 3.12432C8.94004 2.79189 8.06016 2.79189 7.5226 3.12432L2.5667 6.1835C1.98232 6.54287 1.98232 7.1309 2.5667 7.49027L7.48076 10.5225C8.04156 10.8684 8.96461 10.8684 9.52541 10.5225L14.4395 7.49027C15.0212 7.1309 15.0212 6.54242 14.4368 6.1835Z",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 9.18561L2.56328 10.8549C1.97891 11.2143 1.97891 11.8028 2.56328 12.1621L7.47734 15.1939C8.03814 15.5398 8.96119 15.5398 9.52199 15.1939L14.4361 12.1621C15.0237 11.8028 15.0238 11.2143 14.4394 10.8549L11.6875 9.18561",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.cb579edf0f1f19097a063d7b8946ebeb.svg";
export { ForwardRef as ReactComponent };